export default __webpack_public_path__ + "static/media/FREE_BLOCK.dc033b33.svg";